import React from 'react';
import { useApplication} from 'merchant-api/unified';
import { ContactOndeckPartner } from './ContactOndeckPartner';
import { ContactUs } from './ContactUs';
import { getSalesAgentInfo } from 'merchant-api/spiceroad';

export const NewUser = () => {
  getSalesAgentInfo(); // warm the cache in parallel
  const { applicationData, isPartnerChannel, isLoadingApplication } = useApplication();
  if (isLoadingApplication) return null;

  if (isPartnerChannel && applicationData?.type === 'NEW') {
    return <ContactOndeckPartner />;
  }

  return <ContactUs />;
}

export default NewUser;
